/**
 * Vacht Vreugde: chatknop vrij van de koopknop op mobiele productpagina's (fase 10D.2).
 *
 * De Shopify Inbox-chatknop staat vast rechtsonder en viel over de koopknop. Op mobiele productpagina's:
 * 1. Hoogte: de knop komt net boven de beginpositie van de koopregel (variabele --vv-chat-offset, die
 *    vv-theme.css §17 doorgeeft aan de officiële Inbox-variabele --shopify-chat-activator-offset).
 *    Minimaal 88px, maximaal de helft van het scherm.
 * 2. Tijdens het scrollen schuift de koopregel alsnog door die zone; zolang dat zo is, krijgt <html> de
 *    klasse vv-chat-clear en is alleen de GESLOTEN chatknop onzichtbaar. Een geopend chatvenster wordt
 *    nooit verborgen. Geen wijziging aan de chat zelf of aan de sticky-koopbalk van Horizon.
 */
(() => {
  const root = document.documentElement;
  const mq = window.matchMedia('(max-width: 749px)');
  const target = document.querySelector('.product-information .product-form-buttons');
  if (!target || !('IntersectionObserver' in window)) return;

  const ACTIVATOR_HEIGHT = 46; // hoogte van de Inbox-knop (zonder tekst)
  const GAP = 8;
  const MIN_OFFSET = 88;
  let observer;
  let timer;

  const previewBar = () => {
    const chat = document.querySelector('shopify-chat');
    return chat ? parseFloat(getComputedStyle(chat).getPropertyValue('--private-preview-bar-offset')) || 0 : 0;
  };

  const setup = () => {
    observer?.disconnect();
    root.classList.remove('vv-chat-clear');
    if (!mq.matches) {
      root.style.removeProperty('--vv-chat-offset');
      return;
    }

    const vh = window.innerHeight;
    const pb = previewBar();
    // Beginpositie van de koopregel in het document (onafhankelijk van de huidige scrollpositie)
    const rowTop = target.getBoundingClientRect().top + window.scrollY;
    const needed = vh - pb - rowTop + GAP; // offset waarbij de knop boven de koopregel staat bij scrollY = 0
    const offset = needed > MIN_OFFSET && needed <= vh * 0.5 ? Math.ceil(needed) : MIN_OFFSET;
    root.style.setProperty('--vv-chat-offset', `${offset}px`);

    // Chatzone (van boven gemeten): van de bovenkant van de knop tot de onderkant
    const bottom = offset + pb;
    const top = vh - bottom - ACTIVATOR_HEIGHT - GAP;
    observer = new IntersectionObserver(
      ([entry]) => root.classList.toggle('vv-chat-clear', entry.isIntersecting),
      { rootMargin: `-${Math.max(0, Math.round(top))}px 0px -${Math.max(0, Math.round(bottom - GAP))}px 0px` }
    );
    observer.observe(target);
  };

  const later = () => {
    clearTimeout(timer);
    timer = setTimeout(setup, 200);
  };

  root.classList.add('vv-pdp');
  setup();
  mq.addEventListener('change', setup);
  window.addEventListener('resize', later);
  window.addEventListener('load', later);
  // De previewbalk-variabele bestaat pas als de Inbox-app geladen is
  customElements.whenDefined('shopify-chat').then(later);
})();
